<div class="add-button-container"
    [tp]="trialCondition ? PremiumTooltipTemplate : null"
    [tpClassName]="'custom-tooltip'"
    [tpPlacement]="'bottom'"
    [tpOffset]="[190, -15]">
    <ng-template #PremiumTooltipTemplate> <app-premium-tooltip [text]="tooltips.premium.competitors"></app-premium-tooltip> </ng-template>
    <app-button
        [text]="'+ Add'"
        [class]="class"
        (click)="toggleExpanded()">
    </app-button>
    <app-select-menu *ngIf="!trialCondition"
        [items]="brandsOptions ?? []"
        [selectMode]="SelectMode.ATTACHED_SINGLE"
        [control]="control"
        [hideSelected]="false"
        [dropDownPosition]="'bottom'"
        [searchable]="false"
        [openPanel]="isPanelOpen"
        (onApply)="onBrandSelected($event)">
    </app-select-menu>
 </div>
